import React from 'react'
import Section from './Section'
import './Home.css'
import Footer from './Footer'

function Home() {
  return (
    <div className='conatiner'>
      <Section 
        title="Model S"
        id="1"                                    // We are using Props here
        description="Order Online For Touchless Delivery"
        backgroundImg="model-s.jpg"
        leftBtnText="Custom Order"
        rightBtnText="Existing Inventory"
      />
      <Section 
        title="Model Y" 
        id="2"                                    // We are using Props here                                   // We are using Props here
        description="Order Online For Touchless Delivery"
        backgroundImg="model-y.jpg"
        leftBtnText="Custom Order"
        rightBtnText="Existing Inventory"
       />
      <Section
        title="Model 3"                                    // We are using Props here
        id="3"                                    // We are using Props here
        description="Order Online For Touchless Delivery"
        backgroundImg="model-3.jpg"
        leftBtnText="Custom Order"
        rightBtnText="Existing Inventory"
      />
      <Section
        title="Model X"                                    // We are using Props here
        id="4"                                    // We are using Props here
        description="Order Online For Touchless Delivery"
        backgroundImg="model-x.jpg"
        leftBtnText="Custom Order"
        rightBtnText="Existing Inventory"
      />
      <Section
        title="Lowest Cost Solar Panels in America"                                    // We are using Props here
        id="5"                                    // We are using Props here
        description="Money-back gaurantee"
        backgroundImg="solar-panel.jpg"
        leftBtnText="Order now"
        rightBtnText="Learn More"
      />
      <Section
        title="Solar for New Roofs"                                    // We are using Props here
        id="6"                                    // We are using Props here
        description="Solar Roof Costs Less Than a New Roof Plus Solar Panels"
        backgroundImg="solar-roof.jpg"
        leftBtnText="Order now"
        rightBtnText="Learn More"
      />
      <Section
        title="Accessories"                                    // We are using Props here
        id="7"                                    // We are using Props here
        description=""
        backgroundImg="accessories.jpg"
        leftBtnText="Shop now"
        rightBtnText=""
      />

      <Footer />
    </div>
  )
}

export default Home




// Props ---> Only some content change on every same page